import * as React from 'react';
import { ReactChild } from 'react';
import { svgLoadingWheel } from '../icons';
import './LoadMask.scss';

export interface IProps {
  children?: ReactChild;
}
export function LoadMask({ children }: IProps) {
  return (
    <div id="spinner">
      <div className="spinner-content">
        {svgLoadingWheel()}
        <h1>{children || 'Vi behandler din forespørsel...'}</h1>
        <h4>Vennligst vent</h4>
      </div>
    </div>
  );
}

export default LoadMask;



// WEBPACK FOOTER //
// ./src/layout-components/LoadMask.tsx